import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import ControlledGrid from '../Helper/ControlledGrid';
import GeometryGrid from '../Helper/GeometryGrid';
import Grid from '../Helper/Grid';
import GridFilter from '../Helper/GridFilter';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Alerte from './Alerte';
import Document from './Document';
import Observation from './Observation';
import Station from './Station';
import Valeur from './Valeur';

class ElementProjet extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "ElementProjet";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Filter list
    const valeurFilters = this.getValeurFilters();

    const valeurExportConfig = {
      parent: this,
      gridRef: "Valeur",
    };

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'élément de projet.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idElementProjet" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={(this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet)} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="libelle">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Libellé</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("libelle")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire1">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire1")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaire2">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire 2</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaire2")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Station ManyToMany */}
          <PermissionCheck component={Station.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="stations">
            <Col componentClass={ControlLabel} sm={2}>Stations</Col>
            <Col sm={6}>
              <ControlledGrid ref="stationsGrid" path="stations" objectPath={"elementprojets_stations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/stations"} objectClass={Station}
                mode={this.state.mode} cbxUrl={REST_API_URL + "elementprojets_stations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/stations/inverse/"}
                optionValueKey="idStation" optionLabelKey="nom" onlyDelete={false} autocommit={true} closeModalOnAdd={false} />
            </Col>
            </FormGroup>
          </PermissionCheck>

          {/* Observation ManyToMany */}
          <PermissionCheck component={Observation.getClassName()} permission={PERMISSION_READ}>
            <FormGroup controlId="observations">
            <Col componentClass={ControlLabel} sm={2}>Observations</Col>
            <Col sm={6}>
              <ControlledGrid ref="observationsGrid" path="observations" objectPath={"elementprojets_observations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/observations"} objectClass={Observation}
                mode={this.state.mode} cbxUrl={REST_API_URL + "elementprojets_observations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/observations/inverse/"}
                optionValueKey="idObservation" optionLabelKey="titre" onlyDelete={false} autocommit={true} closeModalOnAdd={false} />
            </Col>
            </FormGroup>
          </PermissionCheck>


          {/* Valeur OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Valeur.getClassName()} permission={PERMISSION_READ}>
              <div>
                <Grid title="Valeurs" path="valeurs" objectPath={"elementprojets/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/valeurs"}
                  ref={"grid" + Valeur.getClassName()} objectClass={Valeur} hiddable={true} mode={this.state.mode}
                  filters={<GridFilter objectClass={Valeur.getClassName()} filters={valeurFilters} parent={this} asForm={false} hiddable={false} formattedFilters={true} />}
                  exportCsv={valeurExportConfig} />
              </div>
            </PermissionCheck>
          }

          {/* Geom OneToMany */}
          {(this.state.mode !== "add") ?
            <GeometryGrid title="Géométries" path="elementprojets_geoms" objectPath={"elementprojets_geoms/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet)} objectClass={ElementProjet}
              mode={this.state.mode} queryLayers={"ElementProjetCreate"}
              allowDraw={true} selectionMultiple={true} typeGeometry="all" withImportCsv={false} withImportPoint={false} /> : null
          }

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"elementprojets/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/documents"} objectClass={Document}
                hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Alerte OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" path="alertes" objectPath={"elementprojets/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/alertes"} objectClass={Alerte}
                hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup> : ""
          }
  			</Form>

      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idElementProjet";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();
    let elementProjetObj = cloneObject(this.state.object);

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
      if(this.refs.stationsGrid !== undefined) elementProjetObj.stations = this.refs.stationsGrid.getArrayToSave();
      if(this.refs.observationsGrid !== undefined) elementProjetObj.observations = this.refs.observationsGrid.getArrayToSave();
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(elementProjetObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.saveGrids();
        this.setState({
          status: {
            type: 'success',
            message: 'Projet sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Projet sauvegardé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/elementprojets/" + newObj[this.getIdField()] + "/edit", state);
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * saveGrids
  * Saves the ManyToMany components
  **/
  saveGrids() {
    if(this.refs.stationsGrid !== undefined) this.refs.stationsGrid.saveAll();
    if(this.refs.observationsGrid !== undefined) this.refs.observationsGrid.saveAll();
  }

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs.gridValeur;
    grid.applyFilter(fieldName, value);
  }

  /**
  * applyDateFilter
  * Filters the grid
  **/
  applyDateFilter(filterField, dateValue, comparatorValue) {
    const grid = this.refs.gridValeur;
    grid.applyDateFilter(filterField, dateValue, comparatorValue);
  }

  /**
  * applyDateIntervalFilter
  * Filters the grid
  **/
  applyDateIntervalFilter(fieldName, values) {
    const grid = this.refs.gridValeur;
    grid.applyDateIntervalFilter(fieldName, values);
  }

  /**
  * applyArrayFilter
  * Filters the grid
  **/
  applyArrayFilter(fieldName, value) {
    const grid = this.refs.gridValeur;
    grid.applyArrayFilter(fieldName, value);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs.gridValeur;
    grid.clearFilters();
  }

  /**
  * getValeurFilters
  * Returns the Valeur grid filters
  **/
  getValeurFilters() {
    return [{
      title: "Date de l'observation",
      type: "dateinterval",
      name: "dateObservation",
      rowIdx: 1,
    },{
      title: "Observation",
      type: "combo",
      name: "idObservation",
      optionValueKey: "idObservation",
      optionLabelKey: "titre",
      url: REST_API_URL + "/elementprojets_observations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/observations",
      rowIdx: 1,
    },{
      title: "Station",
      type: "combo",
      name: "idStation",
      optionValueKey: "idStation",
      optionLabelKey: "nom",
      url: REST_API_URL + "/elementprojets_stations/" + (this.getObjectProperty("idElementProjet") || this.props.match.params.idElementProjet) + "/stations",
      rowIdx: 1,
    },{
      title: "Thématique de l'observation",
      type: "combo",
      multi: true,
      isArray: true,
      name: "observation.thematiques",
      optionValueKey: "idThematique",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/thematiques/",
      rowIdx: 2,
    },{
      title: "Mots-clé de l'observation",
      type: "combo",
      multi: true,
      isArray: true,
      name: "observation.motCles",
      optionValueKey: "idMotCle",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/motcles/",
      rowIdx: 2,
    },{
      title: "Thématique de la station",
      type: "combo",
      multi: true,
      isArray: true,
      name: "station.thematiques",
      optionValueKey: "idThematique",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/thematiques/",
      rowIdx: 3,
    },{
      title: "Mots-clé de la station",
      type: "combo",
      multi: true,
      isArray: true,
      name: "station.motCles",
      optionValueKey: "idMotCle",
      optionLabelKey: "libelle",
      url: REST_API_URL + "/motcles/",
      rowIdx: 3,
    }];
  }

}

export default ElementProjet;



// WEBPACK FOOTER //
// ./src/views/Entity/ElementProjet.js